import { render, staticRenderFns } from "./JsHeader.vue?vue&type=template&id=21081b22&"
import script from "./JsHeader.vue?vue&type=script&lang=js&"
export * from "./JsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports